var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    this.getVendor.completed_setup == 1
      ? _c(
          "div",
          [
            _c("b-container", { attrs: { fluid: "" } }, [
              _c("main", { staticClass: "setupHeader" }, [_vm._t("main")], 2),
            ]),
            _vm._v(" "),
            _c(
              "header",
              { staticClass: "header-container" },
              [_vm._t("header")],
              2
            ),
            _vm._v(" "),
            _c(
              "aside",
              { staticClass: "aside-container" },
              [_vm._t("side-navbar")],
              2
            ),
            _vm._v(" "),
            _c("mobile-nav-bar"),
          ],
          1
        )
      : _c(
          "div",
          [
            _c("b-container", { attrs: { fluid: "" } }, [
              _c("main", [_vm._t("main")], 2),
            ]),
            _vm._v(" "),
            _c(
              "aside",
              { staticClass: "aside-container" },
              [_vm._t("side-navbar")],
              2
            ),
            _vm._v(" "),
            _c("mobile-nav-bar"),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }